<template>
  <div class="bank-card-dialog">
    <custom-dialog :title="model.type === 'edit' ? $t('Common.com_edit') : $t('Common.com_add')" :appendToBody="true" :visible="visible" width="600px" v-on="$listeners">
      <div class="dialog-body">
        <!-- 表单 -->
        <el-form :model="bankCardForm" ref="bankCardForm" label-position="left" label-width="120px">
          <el-row>
            <el-form-item :label="$t('crm_bankCardDialog.kai_hu_ming')" prop="depositName" :rules="rules.depositName">
              <el-input v-model.trim="bankCardForm.depositName" style="width: 420px"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('crm_bankCardDialog.yin_hang_zhang_hao')" prop="depositNumber" :rules="rules.depositNumber">
              <el-input v-model.trim="bankCardForm.depositNumber" style="width: 420px"></el-input>
            </el-form-item>
          </el-row>
          <el-row></el-row>
          <el-row>
            <el-form-item :label="$t('crm_bankCardDialog.kai_hu_yin_hang')" prop="depositBank" :rules="rules.depositBank">
              <el-input v-model.trim="bankCardForm.depositBank" style="width: 420px"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('crm_bankCardDialog.zhang_hu_lei_xing')" prop="depositType" :rules="rules.depositType">
              <custom-select v-model.trim="bankCardForm.depositType" code="bank_deposit_type" :placeholder="$t('crm_bankCardDialog.xuan_ze')" style="width: 420px"></custom-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('crm_bankCardDialog.miao_shu')" prop="bankcardDesc">
              <el-input type="textarea" :rows="3" v-model.trim="bankCardForm.bankcardDesc" style="width: 420px"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="addAddress">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      bankCardForm: {
        // bankCode: '', // 开户行
        // bankName: '', // 开户行名称
        depositName: '', // 账户名称
        depositNumber: '', // 账号
        depositBank: '', // 开户银行
        depositType: '', // 账号类型
        bankcardId: '',
        depositPurpose: [], // 账户类型(传空 不用了)
        bankcardDesc: '', // 账户用途
        // bizId: '',
        partnerId: '', // 合作伙伴id(选传 传了就是合作伙伴  不传就是当前用户自己的银行信息)
        partnerOrgId: '',
      },
    };
  },
  mounted() {
    this.initDialog();
    this.rules.depositNumber[0].validator = (rule, value, callback) => {
      const reg = /^([A-Za-z0-9]|-)+$/;
      if (!reg.test(value.toString())) {
        callback(new Error());
      } else {
        callback();
      }
    };
  },

  computed: {
    rules() {
      return {
        // bankCode: [
        //   {
        //     required: true,
        //     message: '请选择开户行',
        //
        //
        //   },
        // ], // 开户行
        depositName: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ], // 账户名称
        depositNumber: [
          {
            required: true,
            validator: null,
            message: this.$t('crm_bankCardDialog.qsrzqdyhzh'),
          },
        ], // 账号
        depositBank: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ], // 开户银行
        depositType: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        // 账户用途
        depositPurpose: [
          {
            type: 'array',
            required: true,
            message: this.$t('Common.com_required'),
            trigger: 'blur',
          },
        ],
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.partnerOrgId) {
        // this.bankCardForm.partnerId = this.model.partnerId;(都拿不到由后端来取)
        // 合作伙伴id(选传 传了就是合作伙伴  不传就是当前用户自己的银行信息)
        this.bankCardForm.partnerOrgId = this.model.partnerOrgId;
      } else {
        this.bankCardForm.partnerOrgId = this.$store.state.userInfo.rootOrgId;
      }
      if (this.model.type === 'edit') {
        this.$setFormatData(this.bankCardForm, this.model.data.item);
        // 后端返回的是数组字符串
        this.bankCardForm.depositPurpose = this.model.data.item.depositPurpose ? JSON.parse(this.model.data.item.depositPurpose) : [];
      } else {
        // 新增时，默认公账
        this.getDicMap('bank_deposit_type', () => {
          this.bankCardForm.depositType = this.dicMap.bank_deposit_type.lang_bank_deposit_type_common;
        });
      }
    },
    onBankCode(item) {
      this.bankCardForm.bankName = item.bankName;
    },
    // 保存基本信息
    addAddress: function () {
      this.$refs.bankCardForm.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'edit') {
          this.$putJSON(apis.partnerBankcardUpdate, this.bankCardForm).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_modify_success'),
                type: 'success',
              });
              this.visible = false;
              this.$emit('success', this.bankCardForm);
            }
          });
        } else if (this.model.partnerId) {
          // 合作伙伴
          this.$postJSON(apis.PartnerBankcardAddByOrgId, this.bankCardForm).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_add_success'),
                type: 'success',
              });
              this.visible = false;
              this.$emit('success', this.bankCardForm);
            }
          });
        } else {
          // 个人
          this.$postJSON(apis.partnerBankcardAdd, this.bankCardForm).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_add_success'),
                type: 'success',
              });
              this.visible = false;
              this.$emit('success', this.bankCardForm);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.bank-card-dialog {
  .title {
    line-height: 24px;
    font-size: 16px;
    padding-left: 10px;
    position: relative;
    color: #595959;
    margin-bottom: 24px;
    .tag {
      width: 4px;
      height: 15px;
      background-color: #00afff;
      left: 0;
    }
  }
}
</style>
